/* Nova Poshta delivery selector (modal version).
   City/branch search through the np-proxy Cloudflare worker, selection
   stored in cart attributes. Вибір відділення одразу зберігається —
   окремої кнопки «Підтвердити» немає. Кнопка оформлення завжди на місці:
   приглушена, доки відділення не обране, і клік по ній відкриває вибір.
   Чекаут відкривається через cart permalink із підставленою адресою. */
(function () {
  'use strict';

  var PROXY_URL = 'https://np-proxy.oleksii-mail.workers.dev/';
  var CHECKOUT_BUTTONS = '#CartDrawer-Checkout, #checkout';
  /* Вибір живе, лише поки покупець у кошику: закрив вікно кошика або
     перейшов на іншу сторінку — вибір скидається. */

  /* ---------- shared state (mirrors cart attributes) ---------- */
  var state = {
    city: '',      // display name, e.g. "м. Київ, Київська обл."
    cityShort: '', // pure name for checkout, e.g. "Київ"
    cityRef: '',
    branch: '',    // warehouse description
    zip: '',
  };
  var pending = {}; // selection inside the modal before "Підтвердити"

  function hasSelection() {
    return !!(state.city && state.branch);
  }

  function api(method, props) {
    return fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modelName: 'AddressGeneral',
        calledMethod: method,
        methodProperties: props,
      }),
    }).then(function (r) { return r.json(); });
  }

  function saveToCart() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Місто доставки': state.city,
          'Відділення Нової Пошти': state.branch,
          '_np_city_short': state.cityShort,
          '_np_city_ref': state.cityRef,
          '_np_index': state.zip,
          '_np_saved_at': '', /* більше не використовується, стираємо залишки */
        },
      }),
    });
  }

  function clearSavedSelection() {
    state.city = '';
    state.cityShort = '';
    state.cityRef = '';
    state.branch = '';
    state.zip = '';
    return saveToCart();
  }

  /* Cart permalink: the only prefill mechanism the new Shopify checkout
     honours. Built from the current cart lines + address params. */
  function goToCheckout() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        var p = new URLSearchParams();
        /* Свідомо передаємо повний рядок від НП — «м. Київ, Київська обл.»,
           а не чисту назву. Причина: в Україні багато однойменних сіл, і
           область у полі міста рятує менеджера від плутанини. Ціна рішення —
           Shopify може позначити адресу як нестандартну. */
        p.set('checkout[shipping_address][city]', state.city);
        p.set('checkout[shipping_address][address1]', state.branch);
        p.set('checkout[shipping_address][zip]', state.zip || '');
        /* країну не передаємо: у магазині доставка лише в Україну,
           тож у чекауті вона й так єдина й обрана за замовчуванням */
        if (cart.note) p.set('note', cart.note);

        /* Промокод передаємо явно, а не сподіваємось на cookie: permalink
           створює новий кошик, і покладатися на неявні механізми тут не варто.
           Автоматичні знижки не чіпаємо — вони застосуються самі, коду в них
           немає. Для знижок за кодом Shopify кладе сам код у поле title. */
        var codes = (cart.cart_level_discount_applications || [])
          .filter(function (d) { return d.type === 'discount_code' && d.title; })
          .map(function (d) { return d.title; });
        if (codes.length) p.set('discount', codes.join(','));
        /* Тільки поточний домен. Раніше тут був window.Shopify.shop —
           технічний myshopify-домен: інший origin, а отже втрачені cookie,
           разом з ними код знижки, і чужа адреса в рядку браузера. */
        var url = window.location.origin + '/cart/' + items + '?' + p.toString();
        /* всі дані вже в url — атрибути кошика чистимо, щоб після
           повернення з чекаута вибір робився заново */
        clearSavedSelection().then(function () {
          window.location.href = url;
        });
      });
  }

  /* ---------- блокування прокрутки сторінки під кошиком ----------
     Тема вішає на body клас overflow-hidden, але на iOS Safari
     `overflow: hidden` не зупиняє тач-скрол: сторінка позаду далі
     гортається, і з відкритою клавіатурою це видно як смугу збоку.
     Надійний спосіб — position: fixed на body із запамʼятованою
     позицією прокрутки. Чіпляємось до класу, який ставить сама тема,
     тож блокування вмикається рівно тоді, коли вона цього хоче. */
  (function () {
    /* тільки сенсорні екрани — на десктопі overflow: hidden працює */
    if (!window.matchMedia('(pointer: coarse)').matches) return;

    var locked = false;
    var savedY = 0;

    /* Свідомо НЕ чіпаємо висоту документа й дровера під клавіатуру:
       дві спроби підганяти їх під visualViewport (з top і без) на iOS
       давали зсув усього кошика вниз. Лишається чистий scroll lock. */

    function lock() {
      if (locked) return;
      locked = true;
      savedY = window.scrollY || window.pageYOffset || 0;
      var s = document.body.style;
      s.position = 'fixed';
      s.top = -savedY + 'px';
      s.left = '0';
      s.right = '0';
      s.width = '100%';
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      var s = document.body.style;
      s.position = '';
      s.top = '';
      s.left = '';
      s.right = '';
      s.width = '';
      window.scrollTo(0, savedY);
    }

    new MutationObserver(function () {
      if (document.body.classList.contains('overflow-hidden')) lock();
      else unlock();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();

  /* якщо сторінка відновлена з кешу браузера (кнопка "назад" із
     чекаута) — перезавантажуємо, щоб показати чистий стан */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('np-delivery')) {
      window.location.reload();
    }
  });

  function updateCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_BUTTONS).forEach(function (btn) {
      btn.classList.toggle('np-ready', hasSelection());
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_BUTTONS);
    if (!btn || !document.querySelector('np-delivery')) return;
    e.preventDefault();
    if (hasSelection()) {
      goToCheckout();
      return;
    }
    /* відділення не обране — замість мертвого кліку відкриваємо вибір */
    var widget = document.querySelector('np-delivery');
    if (widget && widget._npOpenModal) widget._npOpenModal();
  }, true);

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  /* ---------- custom element ---------- */
  var NpDelivery = function () { return Reflect.construct(HTMLElement, [], NpDelivery); };
  NpDelivery.prototype = Object.create(HTMLElement.prototype);

  NpDelivery.prototype.connectedCallback = function () {
    var el = this;

    /* Вибір живе рівно стільки, скільки живе завантажена сторінка.
       Закрили й відкрили кошик, змінили кількість товару — усе на місці.
       Перезавантажили сторінку — памʼять (state) порожня, а атрибути в
       кошику лишились: це і є ознака простроченого вибору, чистимо. */
    var stale = !!(el.dataset.branch && !hasSelection());

    var qs = function (s) { return el.querySelector(s); };
    var modal = qs('[data-np-modal]');
    var cityInput = qs('[data-np-city-input]');
    var cityList = qs('[data-np-city-list]');
    var branchInput = qs('[data-np-branch-input]');
    var branchList = qs('[data-np-branch-list]');
    var status = qs('[data-np-status]');
    var openBtns = el.querySelectorAll('[data-np-open]');
    var triggerBtn = el.querySelector('.np-delivery__open');
    var cityClear = qs('[data-np-clear-city]');
    var branchClear = qs('[data-np-clear-branch]');

    function syncClears() {
      if (cityClear) cityClear.classList.toggle('hidden', !cityInput.value);
      if (branchClear) branchClear.classList.toggle('hidden', !branchInput.value || branchInput.disabled);
    }

    /* Вибір вважається дійсним, лише поки обидва поля заповнені й у них
       стоїть саме те, що покупець обрав зі списку. Стер одне з полів,
       дописав щось руками — вибір анулюється. */
    function selectionValid() {
      return hasSelection() &&
             cityInput.value.trim() === state.city &&
             branchInput.value.trim() === state.branch;
    }

    /* Єдина точка правди для CTA-рядка:
       обидва поля заповнені → «Оформити замовлення»,
       інакше → «Оберіть спосіб доставки». */
    function syncCta() {
      if (hasSelection() && !selectionValid()) clearSavedSelection();
      updateCheckoutButtons();
      triggerBtn.classList.toggle('hidden', hasSelection());
    }

    /* Put the trigger and the confirm button into the CTA row (next to
       "View Cart"), where the checkout button lives. The form itself
       stays above at full width. */
    var ctas = el.nextElementSibling && el.nextElementSibling.classList &&
               el.nextElementSibling.classList.contains('cart__ctas')
      ? el.nextElementSibling
      : (el.parentElement ? el.parentElement.querySelector('.cart__ctas') : null);
    if (ctas) {
      ctas.insertBefore(triggerBtn, ctas.querySelector('[name="checkout"]'));
    }

    /* залишки з минулого візиту — прибираємо і повертаємо кнопку */
    if (stale) {
      clearSavedSelection();
      triggerBtn.classList.remove('hidden');
    }

    /* Ре-рендер тієї ж сторінки (повторне відкриття кошика, зміна
       кількості) — віджет створюється заново з порожніми полями.
       Відновлюємо їх з памʼяті, інакше вибір виглядав би як стертий. */
    if (hasSelection()) {
      pending.city = state.city;
      pending.cityShort = state.cityShort;
      pending.cityRef = state.cityRef;
      pending.branch = state.branch;
      pending.zip = state.zip;
      cityInput.value = state.city;
      branchInput.value = state.branch;
      branchInput.disabled = false;
      /* показуємо форму відкритою — покупець одразу бачить обране
         і може змінити відділення, не шукаючи кнопки */
      modal.classList.remove('hidden');
      syncClears();
    }

    /* Спостерігач за закриттям кошика прибрано: раніше він стирав вибір,
       щойно покупець закривав дровер. Тепер закриття кошика нічого не
       скидає — вибір тримається до перезавантаження сторінки. */

    function setStatus(text) { status.textContent = text || ''; }

    /* keep the CTA row visually pinned while the form above it
       expands/collapses (cart page only — the drawer doesn't scroll) */
    function keepPinned(fn) {
      var inDrawer = el.closest('.drawer__inner');
      var anchor = ctas || el;
      var before = anchor.getBoundingClientRect().top;
      fn();
      if (inDrawer) return;
      var delta = anchor.getBoundingClientRect().top - before;
      if (delta) window.scrollBy(0, delta);
    }

    function openModal() {
      /* форма вже відкрита — не скидаємо введене */
      if (!modal.classList.contains('hidden')) {
        cityInput.focus();
        return;
      }
      keepPinned(function () { modal.classList.remove('hidden'); });
      pending = {};
      cityInput.value = '';
      branchInput.value = '';
      branchInput.disabled = true;
      setStatus('');
      renderList(cityList, [], null);
      renderList(branchList, [], null);
      syncClears();
      /* поля щойно очищені — вибір більше не дійсний */
      syncCta();
      /* autofocus only with a mouse: on touch it pops the keyboard
         and jerks the viewport */
      if (window.matchMedia('(pointer: fine)').matches) {
        setTimeout(function () { cityInput.focus(); }, 50);
      }
    }

    function closeModal() {
      keepPinned(function () { modal.classList.add('hidden'); });
      /* відділення обране — лишається сама кнопка оформлення,
         кнопка вибору зникає (у CTA-рядку для двох немає місця) */
      syncCta();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
    el.querySelectorAll('[data-np-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
    });

    function renderList(listEl, items, onPick) {
      listEl.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'np-delivery__option';
        li.setAttribute('role', 'option');
        li.textContent = item.label;
        li.addEventListener('click', function () { onPick(item); });
        listEl.appendChild(li);
      });
      listEl.classList.toggle('hidden', items.length === 0);

      /* Список тягнеться до нижнього краю екрана, а не обрізається на
         трьох рядках. Рахуємо доступне місце від верху списку донизу
         видимої області (visualViewport враховує відкриту клавіатуру). */
      if (items.length) {
        listEl.style.maxHeight = '';
        var viewportH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var avail = viewportH - listEl.getBoundingClientRect().top - 12;
        listEl.style.maxHeight = Math.max(avail, 120) + 'px';
      }
    }

    /* --- city search --- */
    /* лічильники запитів: відповідь на застарілий запит ігноруємо, інакше
       при швидкому наборі повільна відповідь на «Ки» перетирає список для «Київ» */
    var cityToken = 0;
    var branchToken = 0;

    function searchCityRequest(q, cb) {
      var my = ++cityToken;
      api('searchSettlements', { CityName: q, Limit: '8' }).then(function (d) {
        if (my !== cityToken) return;
        var found = (d.success && d.data && d.data[0] && d.data[0].Addresses) || [];
        cb(found.map(function (a) {
          return {
            label: a.Present,
            present: a.Present,
            short: a.MainDescription,
            ref: a.Ref, /* settlement itself, not the serving city */
            warehouses: parseInt(a.Warehouses, 10) || 0,
          };
        }));
      }).catch(function () {
        if (my !== cityToken) return;
        cb(null);
      });
    }

    var searchCities = debounce(function () {
      var q = cityInput.value.trim();
      if (q.length < 2) { renderList(cityList, [], null); return; }
      setStatus('Шукаю місто…');
      searchCityRequest(q, function (items) {
        if (items === null) { setStatus('Помилка з’єднання, спробуйте ще раз'); return; }
        setStatus(items.length ? '' : 'Місто не знайдено');
        renderList(cityList, items, pickCity);
      });
    }, 350);

    function pickCity(item) {
      pending.city = item.present;
      pending.cityShort = item.short;
      pending.cityRef = item.ref;
      pending.branch = '';
      pending.zip = '';
      cityInput.value = item.present;
      renderList(cityList, [], null);
      renderList(branchList, [], null);
      branchInput.value = '';
      if (!item.warehouses) {
        /* the settlement has no NP points at all */
        branchInput.disabled = true;
        setStatus('У вашому населеному пункті немає відділень Нової Пошти');
        return;
      }
      branchInput.disabled = false;
      /* список більше не показуємо одразу — підказуємо, що робити далі */
      setStatus('Введіть номер відділення або вулицю');
      syncClears();
    }

    /* quick city buttons */
    el.querySelectorAll('[data-np-quick] button').forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.dataset.city;
        cityInput.value = name;
        setStatus('Шукаю місто…');
        searchCityRequest(name, function (items) {
          if (!items || !items.length) { setStatus('Місто не знайдено'); return; }
          setStatus('');
          pickCity(items[0]);
        });
      });
    });

    /* --- branch search --- */
    /* Список зʼявляється лише після введення запиту: одразу після вибору
       міста показувати «відділення №1 і далі» немає сенсу. Ліміт знято —
       показуємо всі збіги, скільки б їх не було. */
    function loadBranches() {
      var q = branchInput.value.trim();
      if (!pending.cityRef) return;
      if (!q) {
        renderList(branchList, [], null);
        setStatus('Введіть номер відділення або вулицю');
        return;
      }
      setStatus('Шукаю відділення…');
      var my = ++branchToken;
      var props = {
        SettlementRef: pending.cityRef,
        FindByString: q,
        Limit: '500',
        Page: '1',
      };
      api('getWarehouses', props).then(function (d) {
        if (my !== branchToken) return;
        setStatus('');
        var found = (d.success && d.data) || [];
        renderList(branchList, found.map(function (w) {
          return { label: w.Description, desc: w.Description, zip: w.PostalCodeUA || '' };
        }), pickBranch);
        if (!found.length) setStatus('Нічого не знайдено, уточніть запит');
      }).catch(function () {
        if (my !== branchToken) return;
        setStatus('Помилка з’єднання, спробуйте ще раз');
      });
    }
    var searchBranches = debounce(loadBranches, 350);

    /* Вибір відділення — останній крок, підтверджувати нічого.
       Зберігаємо одразу і закриваємо форму. */
    function pickBranch(item) {
      pending.branch = item.desc;
      pending.zip = item.zip;
      branchInput.value = item.desc;
      renderList(branchList, [], null);
      syncClears();

      state.city = pending.city;
      state.cityShort = pending.cityShort;
      state.cityRef = pending.cityRef;
      state.branch = pending.branch;
      state.zip = pending.zip;

      setStatus('');

      /* Не чекаємо на відповідь сервера: до чекаута адреса потрапляє
         через permalink зі state, а не з атрибутів кошика. */
      saveToCart();

      /* форму не закриваємо — покупець бачить, що саме обрав.
         Єдина зміна на екрані: кнопка оформлення стає активною. */
      syncCta();
    }

    /* Кнопки «Очистити» немає: скидати вибір ні до чого — «Змінити»
       відкриває форму з чистими полями. */

    if (cityClear) {
      cityClear.addEventListener('click', function () {
        pending = {};
        cityInput.value = '';
        branchInput.value = '';
        branchInput.disabled = true;
        renderList(cityList, [], null);
        renderList(branchList, [], null);
        setStatus('');
        syncClears();
        syncCta();
        cityInput.focus();
      });
    }
    if (branchClear) {
      branchClear.addEventListener('click', function () {
        pending.branch = '';
        pending.zip = '';
        branchInput.value = '';
        renderList(branchList, [], null);
        setStatus(pending.cityRef ? 'Введіть номер відділення або вулицю' : '');
        syncClears();
        syncCta();
        branchInput.focus();
      });
    }

    /* будь-яка ручна правка полів одразу переоцінює стан кнопки */
    cityInput.addEventListener('input', function () { syncClears(); syncCta(); });
    branchInput.addEventListener('input', function () { syncClears(); syncCta(); });

    cityInput.addEventListener('input', searchCities);
    branchInput.addEventListener('input', searchBranches);
    /* обробник focus прибрано: раніше він підвантажував список ще до того,
       як покупець щось ввів */

    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.np-delivery__field')) {
        cityList.classList.add('hidden');
        branchList.classList.add('hidden');
      }
    });

    /* глобальний обробник кліку по кнопці оформлення має чим відкрити форму */
    el._npOpenModal = openModal;

    syncCta();
  };

  if (!customElements.get('np-delivery')) {
    customElements.define('np-delivery', NpDelivery);
  }
})();
